import ajax from "@/libs/Ajax";

let NAME_SPACE = "/aseapi/console/rsrcmgr";

export default {
    queryRcList(params) {
        return ajax.get(`${NAME_SPACE}/rcmgr/listRpbChain`, {params});
    },
    saveRpbChain(data) {
        return ajax.post(`${NAME_SPACE}/rcmgr/saveRpbChain`, data);
    },
    updateRpbChain(data) {
        return ajax.post(`${NAME_SPACE}/rcmgr/updateRpbChain`, data);
    },
    delRc(params) {
        return ajax.post(`${NAME_SPACE}/rcmgr/deleteRpbChain`, params);
    },
    delRcCom(params) {
        return ajax.post(`${NAME_SPACE}/rcmgr/deleteRcCom`, params);
    },
    getRcCom(uuid) {
        return ajax.get(`${NAME_SPACE}/rcmgr/getRcComByRcId`, {params: {uuid: uuid}});
    },
    saveRcCom(data) {
        return ajax.post(`${NAME_SPACE}/rcmgr/saveRcCom`, data);
    },
    updateRcCom(data) {
        return ajax.post(`${NAME_SPACE}/rcmgr/updateRcCom`, data);
    }
};
